import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import Gikam from 'gikam';
var defaultOptions = {
  config: {
    filebrowserImageUploadUrl: Gikam.IFM_CONTEXT + '/core/module/item/files/action/ckeditor-upload',
    editorUrl: Gikam.IFM_CONTEXT + '/static/plugin/ckeditor/ckeditor.js',
    filebrowserImageBrowseUrl: '',
    toolbarCanCollapse: true,
    toolbarStartupExpanded: true,
    baseHref: Gikam.IFM_CONTEXT,
    extraPlugins: [],
    removeButtons: 'template,Save,NewPage,PasteText,PasteFromWord,Paste,Copy,Cut,Scayt,Form,Radio,TextField,Textarea,Select,Button,HiddenField,Language,Iframe,Flash,Link,Unlink,Anchor,About'
  },
  // 案例：{
  //     name: 'refresh',
  //     label: 'refresh',
  //     icon: 'http://localhost:9999/img/search.svg',
  //     exec: function(editor) {
  //         console.info(editor);
  //     }
  // }
  globalExtraPlugins: []
};

var Ckeditor = /*#__PURE__*/function () {
  function Ckeditor() {
    _classCallCheck(this, Ckeditor);
  }

  _createClass(Ckeditor, null, [{
    key: "setDefaultOptions",
    value: function setDefaultOptions(options) {
      Gikam.extend(true, defaultOptions, options.defaultOptions);
    }
  }, {
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return Gikam.deepExtend(defaultOptions);
    }
  }, {
    key: "getOptions",
    value: function getOptions(options) {
      return Gikam.deepExtend(defaultOptions, options);
    }
  }]);

  return Ckeditor;
}();

export { Ckeditor as default };